import { ItemSeparatorItem } from 'common/ui/ItemSeparator';
import { formatDateFromNow } from 'utils/datetime';
import { GetConversationQuery } from 'generated-graphql/graphql';
import { ConversationStatusIconAndLabel } from 'modules/conversations/components/ConversationStatusIconAndLabel';
import { mapType } from 'utils/generatedCampaignMappers';

type ConversationQueryResult = NonNullable<
  GetConversationQuery['getConversation']
>;

export const getCandidateProfileConversationSeparatorItems = (
  conversation: ConversationQueryResult | null
): ItemSeparatorItem[] => {
  if (!conversation) {
    return [];
  }

  const items: ItemSeparatorItem[] = [];

  const campaign = conversation.campaign;
  const jobDescription = campaign?.jobDescriptionParsed;

  if (jobDescription?.employerName) {
    items.push(jobDescription.employerName);
  }

  if (campaign?.atsJobId) {
    items.push(`Job ID ${campaign.atsJobId}`);
  }

  if (conversation.createdAt) {
    items.push(`Started ${formatDateFromNow(conversation.createdAt)}`);
  }

  if (conversation.status) {
    items.push(
      <ConversationStatusIconAndLabel
        status={conversation.status}
        needsReview={!!conversation.needsReview}
        unresolvedNeedsReviewReasons={conversation.unresolvedNeedsReviewReasons}
        errorCode={conversation.errorCode}
        campaignType={mapType(campaign?.type)}
        meetingBookingStatus={conversation.meetingBookingStatus}
        withLabel
      />
    );
  }

  return items;
};
